export default __webpack_public_path__ + "static/media/BW.7d478e0b.svg";